function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n          .user-picture {\n            border-radius: ", ";\n          }\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        .user-picture {\n          height: ", ";\n          width: ", ";\n        }\n        .initials {\n          font-size: ", ";\n          line-height: ", ";\n        }\n        .user-name {\n          font-size: ", ";\n          line-height: ", ";\n        }\n        .user-title {\n          font-size: ", ";\n          line-height: ", ";\n        }\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n\n    .user-container {\n      position: relative;\n      display: flex;\n      align-items: center;\n    }\n\n    .user-picture {\n      background-color: ", ";\n      border: ", " solid ", ";\n      position: relative;\n      border-radius: 50%;\n      flex-shrink: 0;\n\n      &.initials {\n        color: ", ";\n        font-family: ", ";\n        font-weight: ", ";\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        ", "\n      }\n      &.image {\n        background-size: cover;\n        background-repeat: no-repeat;\n      ", "\n      }\n    }\n\n    .user-name {\n      color: ", ";\n      font-family: ", ";\n      font-weight: ", ";\n    }\n\n    .user-title {\n      color: ", ";\n      font-family: ", ";\n      font-weight: ", ";\n      font-size: 0.75rem;\n    }\n\n    .user-name,\n    .user-title {\n      text-align: ", ";\n    }\n\n    .info-container {\n      margin-", ": 0.5rem;\n    }\n\n    ", "\n\n      ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
/*
 * @license
 * Copyright Ahmed Elywa. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */


import styled, { css } from 'styled-components';
var UserStyle = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      size = _ref.size,
      image = _ref.image,
      color = _ref.color,
      shape = _ref.shape;
  return css(_templateObject2(), theme.userPictureBoxBackgroundColor, theme.userPictureBoxBorderWidth, theme.userPictureBoxBorderColor, theme.userInitialsTextColor, theme.userInitialsTextFontFamily, theme.userInitialsTextFontWeight, color && "background-color: ".concat(color, ";"), image && "background-image: ".concat(image, ";"), theme.userNameTextColor, theme.userNameTextFontFamily, theme.userNameTextFontWeight, theme.userTitleTextColor, theme.userTitleTextFontFamily, theme.userTitleTextFontWeight, theme.dir === 'rtl' ? 'right' : 'left', theme.dir === 'rtl' ? 'right' : 'left', size && css(_templateObject3(), theme["user".concat(size, "Height")], theme["user".concat(size, "Width")], theme["user".concat(size, "InitialsTextFontSize")], theme["user".concat(size, "InitialsTextLineHeight")], theme["user".concat(size, "NameTextFontSize")], theme["user".concat(size, "NameTextLineHeight")], theme["user".concat(size, "TitleTextFontSize")], theme["user".concat(size, "TitleTextLineHeight")]), shape && css(_templateObject4(), theme["user".concat(shape, "BorderRadius")]));
});
export default UserStyle;